import aus from "../assets/images/aus.png";
import can from "../assets/images/can.png";
import ind from "../assets/images/ind.png";
import indonesia from "../assets/images/indonesia.png";
import ire from "../assets/images/ire.png";
import kenya from "../assets/images/kenya.png";
import kuwait from "../assets/images/kuwait.png";
import malasia from "../assets/images/malasia.png";
import oman from "../assets/images/oman.png";
import pak from "../assets/images/PAK.png";
import qatar from "../assets/images/qatar.png";
import nz from "../assets/images/nz.png";
import Usa from "../assets/images/U.S.A.png";
import uk from "../assets/images/U.K.png";
import SA from "../assets/images/SA.png";
import uae from "../assets/images/U.A.E.png";
import cet from "../assets/images/cet.png";
import singapur from "../assets/images/singapur.png";
export const timeZoneList = [
  {
    timeZones: "Australia – Adelaide (ACST)",
    country: "Australia",
    city: "Adelaide",
    value: "Australia/Adelaide",
    img: aus,
  },
  {
    timeZones: "Australia (AEST)",
    country: "Australia",
    city: "Brisbane",
    value: "Australia/Brisbane",
    img: aus,
  },
  {
    timeZones: "Australia – Darwin (ACST)",
    country: "Australia",
    city: "Darwin",
    value: "Australia/Darwin",
    img: aus,
  },
  {
    timeZones: "Australia (AEDT)",
    country: "Australia",
    city: "Melbourne",
    value: "Australia/Melbourne",
    img: aus,
  },
  {
    timeZones: "Australia (AWST)",
    country: "Australia",
    city: "Perth",
    value: "Australia/West",
    img: aus,
  },
  {
    timeZones: "Canada (AST)",
    country: "Canada",
    value: "Canada/Atlantic",
    img: can,
  },
  {
    timeZones: "Canada (CST)",
    country: "Canada",
    value: "Canada/Central",
    img: can,
  },
  {
    timeZones: "Canada (EST)",
    country: "Canada",
    value: "Canada/Eastern",
    img: can,
  },
  {
    timeZones: "Canada (MST)",
    country: "Canada",
    value: "Canada/Mountain",
    img: can,
  },
  {
    timeZones: "Canada (PST)",
    country: "Canada",
    value: "Canada/Pacific",
    img: can,
  },
  {
    timeZones: "Canada (NST)",
    country: "Canada",
    value: "Canada/Newfoundland",
    img: can,
  },
  {
    timeZones: "Central European Time (CET)",
    country: "Central European Time",
    value: "CET",
    img: cet,
  },
  {
    timeZones: "India (IST)",
    country: "India",
    value: "Asia/Calcutta",
    img: ind,
  },
  {
    timeZones: "Indonesia (WST)",
    country: "Indonesia",
    value: "Asia/Jayapura",
    img: indonesia,
  },
  {
    timeZones: "Indonesia (WIB)",
    country: "Indonesia",
    value: "Asia/Jakarta",
    img: indonesia,
  },
  {
    timeZones: "Ireland (IST)",
    country: "Ireland",
    value: "Eire",
    img: ire,
  },
  {
    timeZones: "Kenya (EAT)",
    country: "Kenya",
    value: "Africa/Asmera",
    img: kenya,
  },
  {
    timeZones: "Kuwait (AST)",
    country: "Kuwait",
    value: "Asia/Kuwait",
    img: kuwait,
  },
  {
    timeZones: "Malaysia (MYT)",
    country: "Malaysia",
    value: "Asia/Kuala_Lumpur",
    img: malasia,
  },
  {
    timeZones: "New Zeland (NZ)",
    country: "New Zeland",
    value: "NZ",
    img: nz,
  },
  {
    timeZones: "New Zeland (NZ-CHAT)",
    country: "New Zeland",
    value: "NZ-CHAT",
    img: nz,
  },
  {
    timeZones: "Qatar (AST)",
    country: "Qatar",
    value: "Asia/Qatar",
    img: qatar,
  },
  {
    timeZones: "Singapore (SGT)",
    country: "Singapore",
    value: "Asia/Singapore",
    img: singapur,
  },
  {
    timeZones: "South Africa (SAST)",
    country: "South Africa",
    value: "Africa/Johannesburg",
    img: SA,
  },
  {
    timeZones: "UAE (GST)",
    country: "UAE",
    value: "Asia/Dubai",
    img: uae,
  },
  {
    timeZones: "UK (BST)",
    country: "UK",
    value: "Europe/London",
    img: uk,
  },
  {
    timeZones: "USA (CST)",
    country: "USA",
    value: "US/Central",
    img: Usa,
  },
  {
    timeZones: "USA (EST)",
    country: "USA",
    value: "US/Eastern",
    img: Usa,
  },
  {
    timeZones: "USA (MST)",
    country: "USA",
    value: "US/Mountain",
    img: Usa,
  },
  {
    timeZones: "USA (PST)",
    country: "USA",
    value: "US/Pacific",
    img: Usa,
  },
  {
    timeZones: "Pakistan (PKT)",
    country: "Pakistan",
    value: "Asia/Karachi",
    img: pak,
  },
  {
    timeZones: "Oman (OMT)",
    country: "Oman",
    value: "Asia/Muscat",
    img: oman,
  },
];
